<template>
  <div class="page404">
    <div class="page404__text-box">
      <div class="page404__text--big">404</div>
      <div class="page404__text--normal page404__text--grey">
        Page Not Found
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>
